import React, { createContext, useContext } from "react";
import useAuth from "./useAuth";
import { CartContext } from './CartContext';
export const UserContext = createContext();


const UserContextProvider = ({ children }) => {
   
    const auth = useAuth();

    return (
        <UserContext.Provider value={auth}>
            {children}
        </UserContext.Provider>
    );
};

export default UserContextProvider;
